import type { ProductionEntry } from "./models";

export function operatorQuantityRecords(entries: readonly ProductionEntry[]): ProductionEntry[] {
  return entries.filter((entry) => entry.source
    ? entry.source !== "PLC_COUNTER"
    // Older server/demo records predate the explicit source field.
    : !(entry.type === "PRODUCTION" && entry.enteredByName === "PLC sayacı"));
}
